import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import {
  ModalDismissReasons,
  NgbModal,
  NgbModalConfig,
} from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import {
  NgbdSortableHeader,
  SortEvent,
} from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { EditCampaignComponent } from './edit-campaign/edit-campaign.component';
import { CampaignRequestModel } from './../../../business-entities/campaign-modal';
import { CampaignServiceService } from '../../../business-services/campaign-service.service';
import * as fromEnums from './../../../../../../Autofacets-Core/src/app/utils/enums';
import { UserRoleMenu } from '../../../business-entities/user-role-menu.model';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-campaign',
  templateUrl: './campaign.component.html',
  styleUrls: ['./campaign.component.css'],
})
export class CampaignComponent implements OnInit {
  //#region Declaration
  userRoleRightsDetails: UserRoleMenu;
  isAdvanceSearch: boolean = false;
  campaignList: any;
  debounceTimer: any;
  selectedDate: any[]= [];
  bookingDate: any = null;
  totalCount: number = 0;
  scrollDistance = 1;
  throttle = 100;
  popupCloseResult = false;
  campaignRequestModel: CampaignRequestModel = {
    sortColumn: '',
    sortDirection: '',
    startRecordNumber: 0,
    numberOfRecord: 25,
    searchTerm: '',
    fromToDate: '',
    campaignType: null,
    campaignVia: null,
    campaignStatus: null,
    campaignFor: 0,
  };
  myDateRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({},{
    containerClass: 'theme-dark-blue',
    displayMonths:1,
    showWeekNumbers:false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'custom-today-class'
  });
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  campaignForList = [
    { id: 0, name: 'lblAllCampaigns' },
    { id: 1, name: 'lblSalesCampaigns' },
    { id: 2, name: 'lblAftersalesCampaigns' },
  ];

  campaignTypeList = [
    { key: 1, campaignTypeCode: 'lblScheduled' },
    { key: 2, campaignTypeCode: 'lblRecurring' },
    { key: 3, campaignTypeCode: 'lblExecuteNow' },
  ];
  campaignViaList = [
    { key: 1, campaignViaCode: 'lblBoth' },
    { key: 2, campaignViaCode: 'lblEmail' },
    { key: 3, campaignViaCode: 'lblSms' },
  ];
  campaignStatusList = [
    { key: 1, campaignStatusCode: 'lblDraft' },
    { key: 2, campaignStatusCode: 'lblInprogress' },
    { key: 3, campaignStatusCode: 'lblCompleted' },
  ];
  //#endregion

  constructor(
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private userService: UserDataService,
    private campaignServiceService: CampaignServiceService,
    config: NgbModalConfig,
    private _eref: ElementRef,    
    public datepipe: DatePipe,
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit(): void {
    this.campaignRequestModel.startRecordNumber = 0;
    this.getCampaigns();
    this.userRoleRightsDetails = (
      this.userService.currentUserValue.userRoleMenuDetails as any[]
    ).find((menu) => menu.moduleId === fromEnums.ModuleNames.Campaigns);
  }

  //#region API Methods
  async getCampaigns(isReset: boolean = true) {
  let selectedDateFormatted= this.getFormattedDate(this.selectedDate);
    this.campaignRequestModel.fromToDate = this.selectedDate.length != 0
      ? selectedDateFormatted
      : '';

    this.spinner.show();
    await this.campaignServiceService
      .getCampaigns(this.campaignRequestModel)
      .then((res: any) => {
        if (isReset) {
          this.campaignList = [];
          this.totalCount = 0;
        }

        if (res?.data.length > 0) {
          res.data.forEach((element) => {
            element.statistics =
              element.statistics !== null
                ? JSON.parse(element.statistics)
                : null;
          });
          this.campaignList.push(...res.data);
          this.totalCount = res.data[0].totalCount;
        }
      })
      .finally(() => this.spinner.hide());
  }
  //#endregion

  //#region Methods
  @HostListener('document:click', ['$event'])
  onSearchBoxClose(event) {
    if (
      event &&
      event.target.className.indexOf('ng-option') == -1 &&
      event.target.className.indexOf('btn') == -1
    ) {
      if (
        !this._eref.nativeElement
          .getElementsByClassName('advanced-search-box')[0]
          ?.contains(event.target)
      ) {
        this.isAdvanceSearch = false;
      }
    }
  }

  onEdit(flag: any, campaignId: number) {
    const modalref = this.modalService.open(EditCampaignComponent, {
      size: 'lg',
      windowClass: 'EditPopup',
    });
    modalref.componentInstance.actionFlag = flag;
    modalref.componentInstance.campaignId = campaignId;
    modalref.result.then((response) => {
      if (response?.success) {
        this.ngOnInit();
      }
    });
  }

  onDelete(id: number) {
    let modelHeadermsg = this.translate.instant('lblDelete');
    let modelBodymsg = this.translate.instant('lblSureToDelete');
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then(
      (_result) => {
        // This is intentional
      },
      (reason) => {
        this.popupCloseResult = this.getDismissReason(reason);
        if (this.popupCloseResult) {
          this.campaignServiceService
            .deleteCampaign(id)
            .then((response: any) => {
              if (response && response.statusCode == 201) {
                let deletedmsg = this.translate.instant('lblCampaignDeleted');
                this.toastr.success(deletedmsg);
                this.getCampaigns();
              }
            });
        }
      }
    );
  }

  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.campaignRequestModel.sortColumn = column;
    this.campaignRequestModel.sortDirection = direction;
    this.campaignRequestModel.startRecordNumber = 0;
    this.spinner.show();
    this.getCampaigns();
  }

  onScrollDown(_ev) {
    if (this.totalCount > this.campaignList.length) {
      this.campaignRequestModel.startRecordNumber = this.campaignList.length;
      this.getCampaigns(false);
    }
  }

  onSearch() {
    this.campaignRequestModel.startRecordNumber = 0;
    this.debounceFunction(() => this.getCampaigns(), 200);
    this.isAdvanceSearch = false;
  }

  debounceFunction(func, delay) {
    window.clearTimeout(this.debounceTimer);
    this.debounceTimer = window.setTimeout(func, delay);
  }

  onClose() {
    this.isAdvanceSearch = false;
  }

  onAdvanceSearch() {
    this.isAdvanceSearch = !this.isAdvanceSearch;
  }

  onReset() {
    this.selectedDate = [];
    this.campaignRequestModel = {
      sortColumn: '',
      sortDirection: '',
      startRecordNumber: 0,
      numberOfRecord: 25,
      searchTerm: '',
      fromToDate: '',
      campaignType: null,
      campaignVia: null,
      campaignStatus: null,
      campaignFor: 0,
    };
    this.getCampaigns();
  }

  onChange(event) {
    let myDiv = document.getElementById('scrollDiv');
    myDiv.scrollTop = 0;
    this.campaignRequestModel.campaignFor = event;
    this.campaignRequestModel.startRecordNumber = 0;
    this.getCampaigns();
  }
  //#endregion

  getFormattedDate(dateRangeArray: any[]){
    let formattedDate: string= "";
    if(dateRangeArray.length != 0){
      let beginDate= this.datepipe.transform(dateRangeArray[0], 'dd/MM/yyyy');
      let lastDate= this.datepipe.transform(dateRangeArray[1], 'dd/MM/yyyy');
      formattedDate= beginDate + ' - ' + lastDate;
    }
    return formattedDate;
  }
}
